module.exports = __webpack_public_path__ + "img/top.4916fb88.svg";